<template>
  <el-form-item v-if="created" label="onFormSubmit" label-width="150px">
    <el-button
      type="info"
      icon="el-icon-edit"
      plain
      round
      :class="[getFormEventHandled('onFormSubmit') ? 'button-text-highlight' : '']"
      @click="editFormEventHandler('onFormSubmit')"
    >
      {{ i18nt("designer.setting.addEventHandler") }}
    </el-button>
  </el-form-item>
</template>
<script>
import { VFormSDK } from "@/CommonDP/lib/vform/VFormDesigner.umd.min.js";
const { i18n } = VFormSDK;
export default {
  mixins: [i18n],
  props: {
    parent: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return { created: false };
  },
  computed: {
    editFormEventHandler() {
      return this.parent.editFormEventHandler;
    },
    getFormEventHandled() {
      return this.parent.getFormEventHandled;
    }
  },
  created() {
    this.$set(this.parent.eventParamsMap, "onFormSubmit", "onFormSubmit(params, data) {");
    this.created = true;
  }
};
</script>
